import PlatformEvent from "../PlatformEvent";

export default new PlatformEvent("INFO", "ReturnedToPlatform", "ReturnedToPlatform", false)